import { useEffect, useState } from 'react';
import {
  addVenueGeofence,
  getAllGeofences,
  getGeofencesByVenueId,
} from '../../api/new-api';
import { observer } from 'mobx-react';
import { PlusCircleIcon } from '@heroicons/react/24/solid';
import { PEProgressBar } from '../../components/linear-progress';

type Props = {
  loading: boolean;
  venues: any[];
  handleAdd: (locationId: string) => void;
};
const GeofencesToAdd = ({ handleAdd, venues, loading }: Props) => {
  return (
    <div className="mt-4 block h-[35rem] overflow-auto w-full p-6 bg-gray-100 border border-gray-200 rounded-lg shadow">
      <p className="mb-4 font-normal text-xl hover:cursor-pointer text-primary-900">
        Geofences Available To Add: {venues.length ?? 0}
      </p>
      {loading && <PEProgressBar />}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
        {venues.map((v) => (
          <div className="w-full h-max bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="p-5 flex flex-row justify-between items-start">
              <div className="flex-1 min-w-0">
                <p className="mb-3 text-lg font-normal text-gray-700 dark:text-gray-400 truncate">
                  {v.name}
                </p>
              </div>
              <div className="hover:opacity-50 flex-shrink-0 ml-4">
                <PlusCircleIcon
                  onClick={() => {
                    handleAdd(v.locationId);
                  }}
                  className="w-6 h-6"
                  color="green"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default observer(GeofencesToAdd);
